var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParcel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    fill: "#212529",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: ""
  }, /*#__PURE__*/React.createElement("g", {
    id: "budicon-parcel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 4h10.627a1.505 1.505 0 0 0-.19-.19L18.087.33a1.504 1.504 0 0 0-.938-.33H12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 4V0H5.85a1.504 1.504 0 0 0-.936.33L.563 3.81A1.506 1.506 0 0 0 .374 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5v3.5a.5.5 0 0 1-1 0V5H0v14.5A1.497 1.497 0 0 0 1.496 21H1.5c3.66-.005 16.34-.02 20-.008a1.546 1.546 0 0 0 1.06-.435A1.49 1.49 0 0 0 23 19.492V5z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParcel);
export default __webpack_public_path__ + "static/media/Parcel.a060d5c2851b8e8467102e7130cd2786.svg";
export { ForwardRef as ReactComponent };